import React, { ReactNode } from "react";
import { animated, useSpring } from "react-spring";
import styled from "styled-components";

interface IProps {
  testId: string;
  isOpen: boolean;
  children: ReactNode;
}

const closed = {
  transform: "translate3d(0,1000px,0)",
  zIndex: -99,
  bottom: -500
};

const open = {
  transform: "translate3d(0,0,0)",
  zIndex: 10,
  bottom: 0
};

export function AnimatedHidden({ isOpen, children, testId }: IProps) {
  const from = isOpen ? closed : open;
  const to = isOpen ? open : closed;

  const props = useSpring({
    from,
    to,
    config: {
      duration: 200
    }
  });
  return (
    <Bottom style={props} data-testid={testId}>
      {children}
    </Bottom>
  );
}

const Bottom = styled(animated.div)`
  position: absolute;
  width: 100vw;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
`;



// WEBPACK FOOTER //
// ./src/components/common/Keyboard/Keyboard.style.tsx